module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAVCAYAAABYHP4bAAABVklEQVRIibWUvUoDQRSFv+CCWAgpLCw0GLCzsVlwwEKtUtj4BDZprNRqCwuxsJhKBAsLC+MTRPQBRIUFByGtYEgKwS6oRFQUtMhG2MW7fxkPLMzeM2e+ubeYgtKmCsxjX0e+5173f5wAsvoPoAsgBOqrbAkwCVxGi78g33PbNihKm2KwLCltZoN1x5ECFrQTfAC1EEhpUwEqAxx+IBnRjuaA9QFAdeApDegw2JxX98B0Imh3ufwu3ShQZ+u81QVKgv8lBaMdbQDbMaBN4BhoCf4iKUeXRh/AvuA9AONWQL7nvtHr/E8pbSasgJQ2o8CVYFelXJ7RFYCi4Inn5RndCzAl+UqbBSsgpc0wsBYpN33PPYvL5RndCLAXqZ0CmUB1oB2z/wZ4BVYi9cek24VASzNjDaCRFCL7M/XsAHcASpvvjOG0+gROHHrzHkJ4DAdUF6j5nnv7Ax1ASwTLLEquAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/pages/index/assets/img/event/报纸.png
// module id = MeyF
// module chunks = 32